import { Badge } from '@cox/core-ui8/dist/Badge'

import { ReactBadgeProps } from './types'
import withAEM from '../../hoc/withAEM'
import { getTokenValues } from '../../utils/rule-builder-util'

const ReactBadge = (props: ReactBadgeProps): JSX.Element => {
  const {
    contentBadgeText,
    contentBadgeColor: tokenColor,
    tokenProperties,
    isInContainer = false,
    id = '',
    lob = ''
  } = props
  const contentBadgeColor = (getTokenValues(tokenColor, tokenProperties) as string) || ''
  const contentBadgeColorNew = contentBadgeColor?.toLowerCase()

  const BadgeWithAEM = withAEM(Badge)
  return (
    <BadgeWithAEM
      id={id}
      lob={lob}
      text={contentBadgeText}
      variation={contentBadgeColorNew}
      bgColor={contentBadgeColor}
      isSpacing={isInContainer}
    />
  )
}
export default ReactBadge
